<template>
  <section class="showAlertBlock" style="position: relative;margin-right: 2%;margin-left:10%;">
    <i @dblclick="canEdit?showReasonArea():''" :class="comment&&comment!=''?'colorRed':''" class="icon iconfont icon-mulu"></i>
    <div v-if="showSelt==randomId&&canEdit" class="trgle"></div>
    <section v-if="showSelt==randomId&&canEdit" class="reason-area">
      <div>
        <textarea :id="'text-'+randomId" class="mktReasonArea" :maxlength="langVersion=='zh-CN'?20:50" :placeholder="$t('common.ReasonPlaceHolder')" v-model="commentVal"></textarea>
        <p style="text-align: right">
          <span @click="submitComment" style="color:#B62A40;padding: 6px;display: inline-block;cursor:pointer;text-decoration: underline;">{{$t('common.Ok')}}</span>
        </p>
      </div>
    </section>
    <div v-if="showSelt!=randomId&&comment&&comment!=''" class="triangle"></div>
    <div v-if="showSelt!=randomId&&comment&&comment!=''" class="alertBlock">
      {{this.comment}}
    </div>
  </section>
</template>
<script>
export default {
  name: 'rejectComment',
  model: {
    prop: 'comment',
    event: 'changeValue'
  },
  props: [
    'comment',
    'canEdit'
  ],
  data () {
    return {
      langVersion: window.localStorage.getItem('language'),
      commentVal: this.comment || '',
      showSelt: '',
      randomId: 'selectId' + new Date().getTime() + Math.random() * 1000
    }
  },
  created () {
  },
  mounted () {
  },
  destroyed () {
  },
  methods: {
    submitComment () {
      this.showSelt = ''
      this.$emit('changeValue', this.commentVal)
    },
    showReasonArea () {
      if (this.showSelt === '') {
        if (document.querySelectorAll('.reason-area').length > 0) {
          this.$commonJs.alertTips({
            type: 'error',
            content: this.$t('common.RsdEditCheck'),
            stayTime: 3
          })
        } else {
          this.commentVal = this.comment
          this.showSelt = this.randomId
          setTimeout(() => {
            document.getElementById('text-' + this.randomId).focus()
          }, 100)
        }
      } else {
        this.showSelt = ''
      }
    }
  }
}
</script>
<style scoped>
  .reason-area{
    position: absolute;
    right: -20px;
    top: 22px;
  }
  .reason-area div{
    width: 150px;
    background-color: #ffffff;
    position: relative;
    /*right: 130px;*/
    z-index: 1;
    box-shadow: 0px 0px 5px 0px #ccc;
  }
  .reason-area textarea{
    position: relative;
    width: calc(100% - 12px);
    height: 30px;
    padding: 6px;
    resize: none;
  }
  .alertBlock{
    display: none;
    width: 200px;
    background-color: #B62A40;
    line-height: 18px;
    color: #fff;
    position: absolute;
    right: -5px;
    top: 22px;
    z-index: 999;
    padding: 10px 15px;
    border-radius: 4px;
    word-wrap:break-word;
    white-space: normal;
  }
  .trgle{
    width: 0;
    position: absolute;
    top: 10px;
    height: 0;
    border: 6px solid transparent;
    border-bottom-color: #B62A40;
  }
  .triangle{
    display: none;
    width: 0;
    position: absolute;
    top: 10px;
    height: 0;
    border: 6px solid transparent;
    border-bottom-color: #B62A40;
  }
  .showAlertBlock:hover .alertBlock, .showAlertBlock:hover .triangle {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/myComponents/rejectComment.vue